goog.provide("shadow.js.shim.module$date_fns$locale$el$default");
shadow.js.shim.module$date_fns$locale$el$default = esm_import$date_fns$locale$el.default;
